module.exports = __webpack_public_path__ + "static/EWY_Shibon Armstrong_CASE_STUDY-8b401d4af12dd45bb3c71f4226e46ca9.mp4";